/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Inventory_Filter_LowInputs */

const vi_report_inventory_filter_low = /** @type {(inputs: Report_Inventory_Filter_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp hết hàng`)
};

/**

* @param {Report_Inventory_Filter_LowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_inventory_filter_low = /** @type {((inputs?: Report_Inventory_Filter_LowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Inventory_Filter_LowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_inventory_filter_low(inputs)
});